var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('ProdottiDesktop'):_c('ProdottiMobile')}
var staticRenderFns = []

export { render, staticRenderFns }